/**
 * Copyright (c) 2025, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./NonprofitSupporters.css";
import { SHOW_ERRORS, ErrorPreview } from "./ErrorPreview";

// Nonprofit · "them". Who funds this work — businesses and individuals in one
// list, filterable by type, plus the individual figures underneath.
//
// For a signed-in organisation both panels are built from its own payments. A
// real payment carries no "giving rule" — that is a business-account concept
// nothing writes yet — so the rule column becomes the number of gifts, and the
// asks panel, which has no data source at all, is only in the sample preview.
class NonprofitSupporters extends Component {
  render() {
    const vm = this.props.vm;
    const s = vm.sup;
    if (s.loading || s.error) {
      return <div className="Marketplace-card Marketplace-status">{s.error ? vm.m.dashError : vm.m.dashLoading}</div>;
    }
    return (
      <div className="Marketplace-Sup">
        {SHOW_ERRORS && <ErrorPreview m={vm.m} className="Marketplace-card Marketplace-status" keys={["dashError"]} />}
        <div className="Marketplace-card">
          <div className="Marketplace-cardHead">
            <span className="Marketplace-cardTitle">{s.title}</span>
            {!!s.filters.length && (
              <div className="Marketplace-chipRow">
                {s.filters.map((f) => (
                  <div
                    className={"Marketplace-chip" + (f.active ? " Marketplace-chip--active" : "")}
                    onClick={f.pick}
                    key={f.id}
                  >
                    {f.label}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="Marketplace-Sup-note">{s.note}</div>
          <div className="Marketplace-Sup-table">
            <div className="Marketplace-Sup-row Marketplace-Sup-row--head">
              <span>{s.isReal ? vm.m.colSupporter : vm.m.colBusiness}</span>
              <span>{s.isReal ? vm.m.colGifts : vm.m.colRule}</span>
              <span className="Marketplace-right">{vm.m.colThisMonth}</span>
              <span className="Marketplace-right">{vm.m.colSince}</span>
              <span className="Marketplace-right">{vm.m.colTotal}</span>
            </div>
            {s.rows.map((b) => (
              <div className="Marketplace-Sup-row" key={b.id}>
                <div className="Marketplace-Sup-biz">
                  <div className="Marketplace-mono">{b.mono}</div>
                  <div>
                    <div className="Marketplace-Sup-name">{b.name}</div>
                    {b.meta && <div className="Marketplace-Sup-meta">{b.meta}</div>}
                  </div>
                </div>
                <div>
                  {s.isReal ? (
                    <span className="Marketplace-Sup-gifts">{b.gifts}</span>
                  ) : (
                    <span className="Marketplace-ruleChip">{b.rule}</span>
                  )}
                </div>
                <span className="Marketplace-right Marketplace-Sup-month">{b.monthLabel}</span>
                <span className="Marketplace-right Marketplace-Sup-since">{b.since}</span>
                <div className="Marketplace-right">
                  <div className="Marketplace-Sup-total">{b.totalLabel}</div>
                  {b.trend && (
                    <div className="Marketplace-Sup-trend" style={{ color: b.trendColor }}>
                      {b.trend}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
          {!s.rows.length && <div className="Marketplace-empty">{s.emptyLabel}</div>}
        </div>

        <div className={"Marketplace-Sup-lower" + (s.asks.length ? "" : " Marketplace-Sup-lower--single")}>
          <div className="Marketplace-card">
            <div className="Marketplace-cardTitle">{vm.m.supIndTitle}</div>
            <div className="Marketplace-Sup-stats">
              <div>
                <div className="Marketplace-Sup-statValue">{s.stats.monthly}</div>
                <div className="Marketplace-Sup-statLabel">{vm.m.supIndMonthly}</div>
              </div>
              <div>
                <div className="Marketplace-Sup-statValue">{s.stats.median}</div>
                <div className="Marketplace-Sup-statLabel">
                  {s.isReal ? vm.m.supIndMedianReal : vm.m.supIndMedian}
                </div>
              </div>
              <div>
                <div className="Marketplace-Sup-statValue Marketplace-Sup-statValue--up">
                  {s.stats.newThisMonth}
                </div>
                <div className="Marketplace-Sup-statLabel">{vm.m.supIndNew}</div>
              </div>
            </div>
            {s.indBody && <p className="Marketplace-Sup-body">{s.indBody}</p>}
          </div>

          {!!s.asks.length && (
            <div className="Marketplace-card">
              <div className="Marketplace-cardTitle">{vm.m.asksTitle}</div>
              <div className="Marketplace-Sup-asks">
                {s.asks.map((a) => (
                  <div className="Marketplace-Sup-ask" key={a.id}>
                    <div className="Marketplace-Sup-askInfo">
                      <div className="Marketplace-Sup-askWho">{a.who}</div>
                      <div className="Marketplace-Sup-askMsg">{a.msg}</div>
                    </div>
                    <div className="Marketplace-Sup-askBtn">{a.action}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

NonprofitSupporters.propTypes = {
  vm: PropTypes.object.isRequired,
};

export default NonprofitSupporters;
